import React, { memo, useMemo } from "react";
import { LogLabelsProps } from "../types";
import { getLabelColor } from "../utils/labelProcessor";
import { useAppSelector } from "../../../store/hooks";
import "./LogLabels.css";

/**
 * Displays labels as colored chips within a fixed-width container
 * Labels wrap within the container and can cause variable row height
 */
export const LogLabels = memo(function LogLabels({ labels, width, onLabelClick }: LogLabelsProps) {
  const theme = useAppSelector((state) => state.theme.theme);
  const isDarkTheme = theme === "dark";

  // Memoize colors based on labels and theme
  const labelColors = useMemo(() => {
    return labels.map(([key]) => getLabelColor(key, isDarkTheme));
  }, [labels, isDarkTheme]);

  if (labels.length === 0) {
    return <div className="log-labels" style={{ width }} />;
  }

  return (
    <div className="log-labels" style={{ width }}>
      {labels.map(([key, value], index) => {
        const color = labelColors[index];
        const labelText = `${key}=${value}`;

        return (
          <span
            key={`${key}-${value}-${index}`}
            className={`log-label-chip${onLabelClick ? " log-label-chip--clickable" : ""}`}
            style={{ backgroundColor: color }}
            title={labelText}
            onClick={onLabelClick ? (e) => { e.stopPropagation(); onLabelClick(key, value); } : undefined}
          >
            {labelText}
          </span>
        );
      })}
    </div>
  );
});
